import ResidentialTintLanding from "@/components/ResidentialTintLanding";

/**
 * Meta Ads landing page — /lp/residential-tint
 * Minimal header (no site nav), noindex. Layout shared with the website
 * residential-tint page via ResidentialTintLanding.
 */
export default function ResidentialTintLP() {
  return (
    <ResidentialTintLanding
      source="Meta Ads — Residential Tint LP"
      lpKey="residential-tint"
      trackLocation="lp-residential-tint"
      testidPrefix="lp"
      showAdsHeader
      mobileOfferHero
      seo={{
        title: "Cut your AC bill. Stop the fade. Ceramic home window tint in Prescott, AZ — 928 Wraps",
        description: "Ceramic residential window tint in Prescott Valley, Prescott & Chino Valley. Lower cooling bills, block 99% UV, more privacy — installed by Northern Arizona's owner-operated shop. Free in-home estimate.",
        path: "/lp/residential-tint",
        noindex: true,
      }}
    />
  );
}
